import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  updateRequest,
  updateSuccess,
  updateFailure,
  detailRequest,
  detailSuccess,
  detailFailure,
  upsertRequest,
  upsertSuccess,
  upsertFailure,
} from './genericReducers'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  emailSettingsUpdateRequest: ['params', 'callback'],
  emailSettingsUpdateSuccess: ['data'],
  emailSettingsUpdateFailure: ['error'],

  emailSettingsDetailRequest: [],
  emailSettingsDetailSuccess: ['detailData'],
  emailSettingsDetailFailure: ['detailError'],

  emailSettingsTextDetailRequest: [],
  emailSettingsTextDetailSuccess: ['textDetailData'],
  emailSettingsTextDetailFailure: ['textDetailError'],

  emailSettingsUpsertRequest: ['params', 'callback'],
  emailSettingsUpsertSuccess: [''],
  emailSettingsUpsertFailure: ['error'],

  resendVerificationEmail: [],
})

export const EmailSettingsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  updateData: {},
  updateError: null,
  updateFetching: false,

  detailData: {},
  detailError: null,
  detailFetching: false,

  textDetailData: {},
  textDetailError: null,
  textDetailFetching: false,

  upsertData: {},
  upsertError: null,
  upsertFetching: false,
})

/* ------------- Reducers ------------- */

export const textDetailRequest = (state) => {
  return state.merge({ textDetailFetching: true, textDetailError: null })
}

export const textDetailSuccess = (state, { textDetailData }) => {
  return state.merge({ textDetailData, textDetailFetching: false })
}

export const textDetailFailure = (state, { textDetailError }) => {
  return state.merge({ textDetailError, textDetailFetching: false })
}

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const EmailSettingsSelectors = {}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.EMAIL_SETTINGS_UPDATE_REQUEST]: updateRequest,
  [Types.EMAIL_SETTINGS_UPDATE_SUCCESS]: updateSuccess,
  [Types.EMAIL_SETTINGS_UPDATE_FAILURE]: updateFailure,

  [Types.EMAIL_SETTINGS_UPSERT_REQUEST]: upsertRequest,
  [Types.EMAIL_SETTINGS_UPSERT_SUCCESS]: upsertSuccess,
  [Types.EMAIL_SETTINGS_UPSERT_FAILURE]: upsertFailure,

  [Types.EMAIL_SETTINGS_DETAIL_REQUEST]: detailRequest,
  [Types.EMAIL_SETTINGS_DETAIL_SUCCESS]: detailSuccess,
  [Types.EMAIL_SETTINGS_DETAIL_FAILURE]: detailFailure,

  [Types.EMAIL_SETTINGS_TEXT_DETAIL_REQUEST]: textDetailRequest,
  [Types.EMAIL_SETTINGS_TEXT_DETAIL_SUCCESS]: textDetailSuccess,
  [Types.EMAIL_SETTINGS_TEXT_DETAIL_FAILURE]: textDetailFailure,
})
